<!--
 * @Author: wang.y 
 * @Date: 2022-02-17 16:24:17
 * @LastEditors: lan.h
 * @LastEditTime: 2022-03-28 11:14:52
 * @Description: 公司数据库
-->
<template>
  <div class="comp-data">
    <div class="comp-data-top">
      <div class="total">全部<span>（{{total}}）</span></div>
      <div class="action" @click="goComp">筛选更多公司数据</div>
    </div>
    <CheckboxGroup v-model="check_uids" @on-change="haddleCheckbox" class="check-uids">
      <Table :columns="listColumns" :data="listData">
        <template slot-scope="{ row }" slot="name">
          <div class="comp-item">
            <div class="comp-logo" @click="goToDetail(row.uid)">
              <img :src="row.logo_path | logo_show" />
            </div>
            <div class="comp-decs">
              <div class="p1" @click="goToDetail(row.uid)">{{row.short_name}}</div>
              <a :href="$store.state.index_path + '/companyDetail/' + row.uid"></a>
            </div>
          </div>
        </template>
      </Table> 
    </CheckboxGroup>
    <Affix :offset-bottom="20" class="contrast" v-if="capture && com_list.length > 1">
      <div class="contrast_c">
        <div class="contrast_l">
            <div class="c_li" v-for="item in com_list" :key="item.uid">
                <div class="logo_img">
                    <img :src="item.logo_path | logo_show" />
                </div>
                <div class="com_name">
                    <p class="over-p1">{{item.short_name}}</p>
                </div>
                <!-- <div class="com_a">
                    <a @click="haddleDeteleCom(item.uid)" v-if="item.uid != uid">删除</a>
                </div> -->
            </div>
            <div class="c_li c_li2" v-if="com_list.length < 4">
                <div class="logo_img">{{4 - com_list.length}}</div>
                <div class="com_name">
                    <p>您还可以继续添加</p>
                </div>
            </div>
        </div>
        <div class="c_btn">
            <a @click="haddleCompare()">一键对比</a>
        </div>
      </div>
    </Affix>
    <Spin fix v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
  </div>
</template>
<script>
import { compList } from '@/service.js'
import filter from 'js/filter'
export default {
  components: {},
  created() {
    this.getEntityList()
  },
  data() {
    return {
      check_uids: [],
      params: {
        round_id: [],
        demostic: null,
        address_id: [],
        year: '',
        s_time: '',
        e_time: '',
        user_key: this.$store.state.user_key,
        tag_arr: [],
        keyword: '',
        page: 1,
        sort_type: 0,
      },
      loading: true,
      listData: [],
      listColumns: [
        { title: '公司名称', width: 160, slot: 'name' },
        {
          title: '简要介绍', width: 160, render: (h, params) => {
            return h('div', { class: 'over-p2' }, filter.empty(params.row.description))
          }
        },
        {
          title: '地区', width: 120, render: (h, params) => {
            return h('span', filter.addressDeal(params.row.address_id, '2'))
          }
        },
        {
          title: '当前轮次', width: 100, render: (h, params) => {
            return h('span', filter.deal(params.row.round_id, 'round'))
          }
        },
        {
          title: '成立时间', width: 100, render: (h, params) => {
            return h('span', filter.timeTrans(params.row.setup_time))
          }
        },
        {
          title: '最新融资金额', width: 120, render: (h, params) => {
            return h('span', filter.amountPrecise(
              params.row.latest_event.amount,
              params.row.latest_event.unit_id,
              params.row.latest_event.precise
            ))
          }
        },
        {
          title: '投资方', minWidth: 110, render: (h, params) => {
            if (params.row.latest_event.tzf_arr && params.row.latest_event.tzf_arr.length > 0) {
              let tzf = []
              params.row.latest_event.tzf_arr.map((a, index) => {
                if (a.entity_type != '2') {
                  tzf.push(h('a', { on: { click: () => { this.goEntityDetail(a.entity_uid, a.entity_type) } } }, a.short_name))
                } else {
                  tzf.push(h('span', a.name))
                }
                if (index < params.row.latest_event.tzf_arr.length - 1) tzf.push(h('span', '、'))
              })
              return h('div', { class: 'over-p2' }, tzf)
            } else {
              return h('span', '未透露')
            }
          }
        }, {
          title: '选择对比', width: 88, align: 'center', render: (h, params) => {
            return h('Checkbox', { props: { label: params.row.uid }, })
          }
        }],
      total: 0,

      com_list: [],
      competitor_list: [],
      competitor_arr: [],
      capture: false
    }
  },
  computed: {},
  methods: {
    scrollcContrast() {
      let scroll_top = document.documentElement.scrollTop || document.body.scrollTop;
      var h = document.documentElement.clientHeight||document.body.clientHeight
      if(scroll_top < $('.comp-data').offset().top - h + 90){
        this.capture = false
      }
      else{
        this.capture = true
      }
    },
    /**
     * 获取公司列表
     */
    async getEntityList() {
      let res = await compList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      this.loading = false
      if (res.status == 'success') {
        this.$set(this.$data, 'listData', res.res)
        this.com_list = res.res.filter((e, index) => index < 3)
        this.check_uids = this.com_list.map(item => item.uid)
        if (this.params.page == 1) {
          this.$set(this.$data, 'total', res.count)
        }
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 选择公司
     */
    haddleCheckbox() {
      if(this.check_uids.length > 4){
        this.check_uids = this.check_uids.slice(0, 4)
        this.$Message.warning('已经添加4家公司');
      }
      this.com_list = this.listData.filter((item) => this.check_uids.indexOf(item.uid) != -1)
    },
    haddleDeteleCom(uid) {
      let index = this.check_uids.findIndex(a => {return a == uid})
      this.check_uids.splice(index, 1)
    },
    /**
     * @description: 去对比页面
     * @param {*}
     * @return {*}
     */    
    haddleCompare() {
      const { href } = this.$router.resolve({
        name: "CompanyCompare",
        query: {uids: this.check_uids}
      })
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '找公司(新)', '公司数据库(一键对比)', '点击量'])
    },
    goComp() {
      const { href } = this.$router.resolve({ name: "CompanyList" })
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '找公司(新)', '公司数据库(查看更多)', '点击量'])
    },
    goToDetail(uid) {
      const { href } = this.$router.resolve({ name: 'CompanyDetail', params: { uid: uid } })
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '找公司(新)', '公司数据库(公司)', '点击量'])
    },
    /**
     * 前往实体详情
     * type: 0公司 1机构 2人物 3医院
     */
    goEntityDetail(uid, type, query) {
      if (type == 2) {
        // this.$router.push({name: 'PeoDetail', params: {uid: uid}})
        const {
          href
        } = this.$router.resolve({
          name: "PeoDetail",
          params: {
            uid: uid
          },
          query: query?query:{}
        })
        window.open(href, '_blank')
      } else if (type == 1) {
        // this.$router.push({name: 'OrgDetail', params: {uid: uid}})
        const {
          href
        } = this.$router.resolve({
          name: "OrgDetail",
          params: {
            uid: uid
          },
          query: query?query:{}
        })
        window.open(href, '_blank')
      } else if (type == 0) {
        // this.$router.push({name: 'CompanyDetail', params: {uid: uid}})
        const {
          href
        } = this.$router.resolve({
          name: "CompanyDetail",
          params: {
            uid: uid
          },
          query: query?query:{}
        })
        window.open(href, '_blank')
      } else if (type == 3) {
        // this.$router.push({name: 'HospitalDetail', params: {uid: uid}})
        const {
          href
        } = this.$router.resolve({
          name: "HospitalDetail",
          params: {
            uid: uid
          },
          query: query?query:{}
        })
        window.open(href, '_blank')
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common2.0.stylus'
.comp-data
  background #F8F9FA
  padding 0 50px 20px
  position relative
  &-top
    display flex
    justify-content space-between
    align-items center
    height 60px
    .total
      font-size 18px
      font-weight bold
      color #333333
      line-height 1
      span
        color #666666
    .action
      background #FFEAD8
      border-radius 13px
      height 26px
      display flex
      justify-content center
      align-items center
      padding 0 13px
      color #FA5A00
      cursor pointer
      &:hover
        transition all 0.5s
        background #FA5A00 
        color #fff
  >>> .ivu-table
    tr
      th
        background #EEF5FF
      th, td
        &:first-of-type
          .ivu-table-cell
            padding-left 20px
    .ivu-table-row-hover
      td
        background #f8fbff
  >>> .check-uids
    .ivu-checkbox+span
      display none
.contrast
  .contrast_c
    background-color #FFFFFF
    box-shadow 0px 10px 30px 0px rgba(121, 133, 143, 0.1)
    padding 20px
    display flex
    width 990px
    height 90px
    .contrast_l
      flex auto
      display flex
      .c_li
        flex 0 0 195px
        border-right 1px dashed
        border-color #D5D5D5
        margin-right 20px
        display flex
        .logo_img
          flex 0 0 50px
          height 50px
          background #FFFFFF
          border 1px solid #F5F5F5
          display flex 
          justify-content center 
          align-items center
          img 
            max-height 100% 
            max-width 100%
        .com_name
          flex auto
          margin-left 12px
          padding-top 18px
          p
            color #333333
            font-size 14px
            font-weight 500
            width 105px
        .com_a
          flex 0 0 48px
          text-align center
          padding-top 19px
          a
            color rgba(250, 122, 80, 1)
            cursor pointer
      .c_li2
        .logo_img
          color #ccc
          border-color #323646
          font-size 30px
          background #F9F9F9
          border 1px solid #F5F5F5
          text-align center 
          line-height 50px
        .com_name
          p
            color #999999
            font-weight 500
            width auto
            font-size 14px
    .c_btn
      flex 0 0 60px
      a
        background #FA5A00
        border-radius 4px
        width 90px
        height 28px
        display block
        line-height 28px
        color #fff
        margin 11px auto 0
        text-align center
        font-size 13px
        color #fff
        font-weight 500
        &:hover
          transition all .5s
          background #FF4800
</style>